import { FeatureDTO } from "./FeatureDTO";

export class PrivacyPolicyFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
